module.exports = __webpack_public_path__ + "img/report.9d9953b3.png";